//import axios to make request
import axios from "axios";

// get all zones from distributor
export async function getLaboratories({ commit }) {
  try {
    const { data } = await axios.get("/laboratory/get-aboratories");

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}


export async function getPackagesByName(context, payload) {
  try {
    const { data } = await axios.get(`/laboratory/package-by-name`, {
      params: payload,
    });
    if (data.error) {
      throw data;
    }

    return data;
  } catch (e) {
    return e.response.data;
  }
}